import { makeStyles } from '@material-ui/core';
import { CancelCrudButtons } from '../../../components/ui/CancelCrudButtons';
import { Modal } from '../../../components/ui/Modal';
import { prettyDate } from '../../../config/dateFormatting';
import { IBookingContent } from '../../../planEatApi/PlanEatFacade';

const useStyles = makeStyles((theme: any) => ({
    content: {
        fontSize: 16,
        "& > b" : {
            color: "red"
        }
    }
}));

interface Props {
    hidden: boolean;
    setHidden: React.Dispatch<React.SetStateAction<boolean>>;
    postBooking: () => any;
    userId: string;
    date: Date;
    quantity: number;
    seatingName: string;
}

export const ConfirmAddBookingModal: React.FC<Props> = ({
    hidden,
    setHidden,
    postBooking,
    userId,
    date,
    quantity,
    seatingName
}) => {
    const classes = useStyles()
    
    return (
        <Modal 
            hidden={hidden} 
            setHidden={setHidden} 
            title='Confirm add booking' 
            >
                <div className={classes.content}>
                    Are you sure you want to create a booking for <b>{userId}</b> on the <b>{prettyDate(date,false,true)} - {seatingName}</b>  for <b>{quantity}  person(s)</b>
                </div>
                <CancelCrudButtons 
                    hidden={hidden} 
                    setHidden={setHidden} 
                    isDelete={false} 
                    postEntity={postBooking}
                    postButtonText={"Confirm Booking"}/>
        </Modal>
    )
}